import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import { DEFAULT_ROUTE, STORE_BASE_PATH } from '../../common/constants';

export interface AppState {
    sessionExpiredAcknowledged: boolean;
    pageDisplayed: string;
    legalDisclaimerDisplay: boolean;
    tourHandlingId: string | undefined;
    pastTourFlag: boolean;
    draftExistsFlag: boolean;
}

const initialState: AppState = {
    sessionExpiredAcknowledged: false,
    pageDisplayed: DEFAULT_ROUTE,
    legalDisclaimerDisplay: false,
    tourHandlingId: undefined,
    pastTourFlag: true,
    draftExistsFlag: false,
};

export const appSlice = createSlice({
    name: `${STORE_BASE_PATH}app`,
    initialState,
    reducers: {
        hideSessionExpiredDialog: state => {
            state.sessionExpiredAcknowledged = true;
        },
        updatePage: (state, action: PayloadAction<string>) => {
            state.pageDisplayed = action.payload;
        },
        updateLegalDisclaimer: (state, action: PayloadAction<boolean>) => {
            state.legalDisclaimerDisplay = action.payload;
        },
        updateTourHandlingId: (state, action: PayloadAction<string | undefined>) => {
            state.tourHandlingId = action.payload;
        },
        updatePastTourFlag: (state, action: PayloadAction<boolean>) => {
            state.pastTourFlag = action.payload;
        },
        updateDraftExistsFlag: (state, action: PayloadAction<boolean>) => {
            state.draftExistsFlag = action.payload;
        },
    },
});

export const {
    hideSessionExpiredDialog,
    updatePage,
    updateLegalDisclaimer,
    updateTourHandlingId,
    updatePastTourFlag,
    updateDraftExistsFlag,
} = appSlice.actions;

export default appSlice.reducer;
